module.exports = __webpack_public_path__ + "media/images/edit-5598ca94da320bf19137a14901e06275.png";